import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Loader2, Quote } from "lucide-react";
import { api } from "@/lib/api";

const inputCls = "w-full bg-[#0D0D0C] border border-[#F4F0EB]/10 rounded-lg px-4 py-3 font-sub text-sm text-[#F4F0EB] placeholder:text-[#6E695E] focus:border-[#C88D51]/60 focus:outline-none transition-colors";

export const TestimonialsManager = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", role: "", text: "" });
  const [loading, setLoading] = useState(false);

  const load = () => api.get("/testimonials").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name || !form.text) { toast.error("Nom et texte de l'avis requis."); return; }
    setLoading(true);
    try {
      await api.post("/testimonials", form);
      toast.success("Avis publié ✦");
      setForm({ name: "", role: "", text: "" });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    setLoading(false);
  };

  const remove = async (id) => { await api.delete(`/testimonials/${id}`); toast.success("Avis retiré"); load(); };

  return (
    <div className="grid lg:grid-cols-3 gap-8">
      <div className="bg-[#161513] border border-[#F4F0EB]/8 rounded-xl p-6 h-fit">
        <h3 className="font-serif-d text-xl mb-4">Ajouter un avis</h3>
        <div className="space-y-3">
          <input data-testid="admin-testimonial-name" placeholder="Nom du client" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} />
          <input data-testid="admin-testimonial-role" placeholder="Fonction — Établissement" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className={inputCls} />
          <textarea data-testid="admin-testimonial-text" placeholder="Texte de l'avis…" rows={4} value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} className={inputCls} />
        </div>
        <button data-testid="admin-testimonial-submit" onClick={add} disabled={loading} className="btn-accent w-full mt-4 py-3 font-sub text-sm flex items-center justify-center gap-2 disabled:opacity-60">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />} Publier l'avis
        </button>
      </div>

      <div className="lg:col-span-2 space-y-3">
        {items.length === 0 && <p className="font-sub text-[#6E695E]">Aucun avis pour le moment.</p>}
        {items.map((t) => (
          <div key={t.id} className="bg-[#161513] border border-[#F4F0EB]/8 rounded-xl p-5 flex items-start justify-between gap-4">
            <div>
              <div className="flex items-center gap-2 mb-1"><Quote className="w-4 h-4 text-[#C88D51]" /><span className="font-serif-d text-lg">{t.name}</span></div>
              {t.role && <div className="font-mono-a text-xs uppercase tracking-[0.15em] text-[#6E695E] mb-2">{t.role}</div>}
              <p className="font-sub text-sm text-[#A39E93] italic">“{t.text}”</p>
            </div>
            <button data-testid={`admin-testimonial-delete-${t.id}`} onClick={() => remove(t.id)} className="btn-ghost px-3 py-2 text-xs flex items-center gap-1 shrink-0"><Trash2 className="w-3.5 h-3.5" /> Retirer</button>
          </div>
        ))}
      </div>
    </div>
  );
};
